import { useApp } from "../context/AppContext";
import { Phone, MapPin, Clock, MessageCircle } from "lucide-react";

const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER;

export default function Contact() {
  const { t, lang } = useApp();
  return (
    <div data-testid="contact-page" className="bg-[#fbf8f1] min-h-[80vh]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[11px] tracking-[0.2em] uppercase text-[#b45f06] font-semibold mb-3">
          {lang === "en" ? "Reach out" : "మాతో మాట్లాడండి"}
        </div>
        <h1 className={`text-4xl sm:text-5xl tracking-tighter font-bold text-stone-900 ${lang === "te" ? "font-telugu" : ""}`}>
          {t.contact.title}
        </h1>
        <p className={`mt-3 text-stone-600 max-w-2xl ${lang === "te" ? "font-telugu" : ""}`}>{t.contact.sub}</p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="p-7 bg-[#f2ebd9] border border-stone-200 rounded-sm">
            <MapPin className="text-[#274e13] mb-4" size={22} />
            <div className="text-xs tracking-wider uppercase text-stone-500 font-semibold">{t.contact.address}</div>
            <div className="mt-2 text-stone-900 font-semibold">SRI VENKATESWARA RICE MILL</div>
            <div className="text-sm text-stone-600 mt-1">F. K. Palem, Andhra Pradesh, India</div>
          </div>
          <div className="p-7 bg-[#f2ebd9] border border-stone-200 rounded-sm">
            <Phone className="text-[#274e13] mb-4" size={22} />
            <div className="text-xs tracking-wider uppercase text-stone-500 font-semibold">{t.contact.phone}</div>
            <div className="mt-2 space-y-3">
              <PhoneRow
                display="+91 89777 53672"
                number={process.env.REACT_APP_WHATSAPP_NUMBER}
                testIdPrefix="contact-phone-1"
              />
              {process.env.REACT_APP_SECONDARY_PHONE && (
                <PhoneRow
                  display="+91 70139 16731"
                  number={process.env.REACT_APP_SECONDARY_PHONE}
                  testIdPrefix="contact-phone-2"
                />
              )}
            </div>
          </div>
          <div className="p-7 bg-[#f2ebd9] border border-stone-200 rounded-sm">
            <Clock className="text-[#274e13] mb-4" size={22} />
            <div className="text-xs tracking-wider uppercase text-stone-500 font-semibold">{t.contact.hours}</div>
            <div className="mt-2 text-stone-900 font-semibold">{t.contact.hoursValue}</div>
          </div>
        </div>

        <a
          data-testid="contact-wa-cta"
          href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Hello SVRM!")}`}
          target="_blank"
          rel="noreferrer"
          className="mt-10 inline-flex items-center gap-2 bg-[#274e13] hover:bg-[#38761d] text-white px-7 py-3.5 rounded-sm font-semibold tracking-wide transition-colors"
        >
          <MessageCircle size={16} /> {lang === "en" ? "Chat on WhatsApp" : "వాట్సాప్ లో మాట్లాడండి"}
        </a>
      </div>
    </div>
  );
}

function PhoneRow({ display, number, testIdPrefix }) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <a
        href={`tel:+${number}`}
        className="text-stone-900 font-semibold hover:underline"
        data-testid={`${testIdPrefix}-tel`}
      >
        {display}
      </a>
      <a
        href={`https://wa.me/${number}`}
        target="_blank"
        rel="noreferrer"
        data-testid={`${testIdPrefix}-wa`}
        className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-sm font-semibold transition-colors"
      >
        <MessageCircle size={12} /> WhatsApp
      </a>
    </div>
  );
}
